document.addEventListener("DOMContentLoaded", () => {
  const panelsWrapper = document.querySelectorAll(".accordion__panel");
  const imagesWrapper = document.querySelector(".list--images");
  const textWrapper = document.querySelector(".list--mobile-description");

  const addIndicesToImages = () => {
    const images = imagesWrapper.querySelectorAll(".list__item");
    images.forEach((image, index) => {
      const imgIndex = `<span class="list__count">${index + 1}</span>`;
      image.insertAdjacentHTML("afterbegin", imgIndex);
    });
  };

  const activatePanel = (panelIndex) => {
    panelsWrapper.forEach((panelWrapper, index) => {
      const isActive = index === panelIndex;
      const panelText = panelWrapper.querySelector(".accordion__text");
      const image = imagesWrapper.querySelector(
        `.list__item:nth-child(${index + 1})`
      );
      const text = textWrapper.querySelector(
        `.list__item:nth-child(${index + 1})`
      );

      panelWrapper.classList.toggle("accordion__panel--active", isActive);
      panelText.style.maxHeight = isActive
        ? `${panelText.scrollHeight}px`
        : "0";
      if (image) image.classList.toggle("list__item--active", isActive);
      if (text) text.style.display = isActive ? "flex" : "none";
    });
  };

  const handlePanelClick = (event) => {
    const targetPanel = event.target.closest(".accordion__panel");
    if (!targetPanel) return;
    const panelIndex = Array.from(panelsWrapper).indexOf(targetPanel);
    activatePanel(panelIndex);
  };

  const handleImageClick = (event) => {
    const targetImage = event.target.closest(".list--images .list__item");
    const images = imagesWrapper.querySelectorAll(".list--images .list__item");

    if (!targetImage) return;

    const imageIndex = Array.from(images).indexOf(targetImage);
    activatePanel(imageIndex);
  };

  panelsWrapper.forEach((panel) =>
    panel.addEventListener("click", handlePanelClick)
  );
  imagesWrapper.addEventListener("click", handleImageClick);

  const accordionInit = () => {
    addIndicesToImages();
    activatePanel(0);
  };

  accordionInit();
});
